<template>
  <div>
    <label>{{ title }}</label>
    <div class="row form-group2">
      <el-select
        :disabled="disabled"
        :modelValue="modelValue"
        class="select-info"
        size="large"
        placeholder="Sélectionner"
        @update:modelValue="$emit('update:modelValue', $event)"
      >
        <el-option
          v-for="difficulty in Array.from(ITEM_METADATA.DIFFICULTIES_VALUES)"
          :value="difficulty[0]"
          :label="difficulty[1]"
          :key="difficulty[1]"
          class="select-info"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
import ITEM_METADATA from '@/constants/ITEM_METADATA';

export default {
  name: 'SelectComplexity',
  props: ['modelValue', 'title', 'disabled'],
  data() {
    return {
      ITEM_METADATA,
    };
  },
};
</script>
